// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Types_Page from "../Restaumatic.Analytics.Types.Page/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Analytics_Types_Page.eqPage);
var pageIsSymbol = {
    reflectSymbol: function () {
        return "page";
    }
};
var ChooseTakeawayIsSymbol = {
    reflectSymbol: function () {
        return "ChooseTakeaway";
    }
};
var ChooseTakeaway = function (x) {
    return x;
};
var toFillFormTypeChooseTakea = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeChooseTakeaway_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldChooseTakeaway = function (dictHasField) {
    return dictHasField;
};
var eqChooseTakeaway = {
    eq: function (x) {
        return function (y) {
            return eq(x.page)(y.page);
        };
    }
};
var genericChooseTakeaway = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showChooseTakeaway = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericChooseTakeaway)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(pageIsSymbol)(Restaumatic_Analytics_Types_Page.showPage))))(ChooseTakeawayIsSymbol))
};
var unscrambleDecodeChooseTakeaway = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericChooseTakeaway)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(pageIsSymbol)(Restaumatic_Analytics_Types_Page.unscrambleDecodePage)(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var encodeChooseTakeaway = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericChooseTakeaway)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ChooseTakeawayIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)(pageIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Analytics_Types_Page.encodePage))))))
};
var decodeChooseTakeaway = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericChooseTakeaway)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ChooseTakeawayIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(pageIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Analytics_Types_Page.decodePage))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    ChooseTakeaway,
    genericChooseTakeaway,
    eqChooseTakeaway,
    showChooseTakeaway,
    encodeChooseTakeaway,
    decodeChooseTakeaway,
    unscrambleDecodeChooseTakeaway,
    toFillFormTypeChooseTakea,
    hasFieldChooseTakeaway,
    newtypeChooseTakeaway_
};
